'use strict'

/*
 * Functions that are needed in all views should be added here
 *
 * NOTES: When writing a new function or moving a function here, assume that this function has NO ACCESS TO GLOBAL VARIABLES/FUNCTIONS!
 */
window.SharedMainFunctions = {
    cg1cg2IsValid: function(value) {
        const regexCG1CG2 = /^[0-9]{3}\/[0-9]{3}$/;

        return !!value.match(regexCG1CG2);
    },
    isWIGW: function(cg1cg2Value) {
        const cg1cg2IsValid = this.cg1cg2IsValid(cg1cg2Value);
        if (!cg1cg2IsValid)
            return false;

        const lastDigitInFirstGroup = cg1cg2Value.charAt(cg1cg2Value.indexOf("/") - 1);

        return lastDigitInFirstGroup === "1";
    },
    parseDotNetDate: function(value) {
        if (typeof value !== "string") {
            return null;
        }

        const match = /^\/Date\((-?\d+)([+-]\d{4})?\)\/$/.exec(value);
        if (!match) {
            return null;
        }

        const ms = Number(match[1]);
        return new Date(ms);
    }
};
